import { render, staticRenderFns } from "./DismissalBigScreen.vue?vue&type=template&id=6ea01884&scoped=true"
import script from "./DismissalBigScreen.vue?vue&type=script&lang=js"
export * from "./DismissalBigScreen.vue?vue&type=script&lang=js"
import style0 from "./DismissalBigScreen.vue?vue&type=style&index=0&id=6ea01884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea01884",
  null
  
)

export default component.exports